import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, finalize, Observable } from 'rxjs';
import { Story } from '../model/story/story.model';
import { StoryService } from '../services/story.service';
import { HttpOptions } from '../model/http-options.model';

@Injectable({
  providedIn: 'root',
})
export class AppStateStore {
  /**
   * Dependencies
   */
  private readonly storyService = inject(StoryService);
  // API
  private storyListSubject = new BehaviorSubject<Story[]>([]);
  public storyList$: Observable<Story[]> = this.storyListSubject.asObservable();
  // Loading
  private loadingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public readonly loading$: Observable<boolean> = this.loadingSubject.asObservable();

  public loadStoryListData(options?: HttpOptions): void {
    this.loadingSubject.next(true);
    this.storyService.overview(options).subscribe(
      (storyList: Story[]): void => {
        this.storyListSubject.next(storyList);
        // Mark loading as finished
        this.loadingSubject.next(false);
      },
    );
  }

  public loadStoryById(storyId: string): Observable<Story> {
    setTimeout(() => this.loadingSubject.next(true), 0);
    return this.storyService.getStoryById(storyId)
      .pipe(
        // Mark loading as finished
        finalize(() => this.loadingSubject.next(false)),
      );
  }

  public loadStoryByCollectionId(collectionId: string): Observable<Story> {
    setTimeout(() => this.loadingSubject.next(true), 0);
    return this.storyService.getStoryByCollectionId(collectionId)
      .pipe(
        // Mark loading as finished
        finalize(() => setTimeout(() => this.loadingSubject.next(false), 0)),
      );
  }
}
